import { W as WuiLayout$1, d as defineCustomElement$1 } from './layout.js';

const WuiLayout = WuiLayout$1;
const defineCustomElement = defineCustomElement$1;

export { WuiLayout, defineCustomElement };

//# sourceMappingURL=wui-layout.js.map